// extracted by css-extract-rspack-plugin
export default {"imageAttachment":"ChatImageAttachment-module__imageAttachment__fb440"};